import React from "react";
import AdminLayout from "../components/admin/AdminLayout";

export default function Dashboard() {
  return <AdminLayout />;
}
